import { nanoid } from 'nanoid';

export const generateNanoId = () => nanoid(12);

// Nano ID uses a bigger alphabet, so a similar number of random bits are packed in just 21 symbols instead of 36.
export const generateUUID = () => nanoid();
